import React, { useState, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import Colors from "../../../stories/assets/Colors";
import Fonts from "../../../stories/assets/Fonts";
import classes from "./Notifications.module.css";
import { SideBarMenu } from "../../../stories/SideBarMenu/SideBarMenu";
import { NotificationBox } from "../../../stories/NotificationBox/NotificationBox";
import { LinkButtonWithIcon } from "../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { NotificationFilter } from "../../../stories/NotificationFilter/NotificationFilter";
import { SendFeedbackModal } from "../../../components/Modals/CoachFlow/Notifications/SendFeedback/SendFeedback";
import { SuccessFeedbackModal } from "../../../components/Modals/CoachFlow/Notifications/SuccessFeedback/SuccessFeedback";
import { ReportProblemModal } from "../../../components/Modals/CoachFlow/Notifications/ReportProblem/ReportProblem";
import { ReviewModal } from "../../../components/Modals/CoachFlow/Notifications/Review/Review";
import { DeclinedModal } from "../../../components/Modals/CoachFlow/Notifications/Declined/Declined";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import { NotificationMobile } from "./NotificationMobile";
import { PaginationComponent } from "../../../stories/Pagination/Pagination";
import CancelLesson from "../../../components/Modals/CoachFlow/Notifications/CancelLesson/CancelLesson";

import {
  ChatFilled,
  ChatOutlined,
  HomeFilled,
  Homeoutlined,
  InsightsFilled,
  InsightsOutlined,
  NotificationFilled,
  Notificationoutlined,
  ReviewFilled,
  ReviewOutlined,
  ScheduleFilled,
  ScheduleOutlined,
  ShortLogo,
  doubleTickBlueIcon,
  NotificationAnnouncementIcon,
  singleTickBlueIcon,
} from "../../../constant/imagePath";
import { useHistory, useLocation } from "react-router";

const NotificationDesktop = () => {
  const history = useHistory();
  const location = useLocation();
  const sidebarMenus = [
    {
      icon: Homeoutlined,
      hoverIcon: HomeFilled,
      text: "Todo",
      onClick: () => history.push("/todo"),
      activeText: "todo",
    },
    {
      icon: Notificationoutlined,
      hoverIcon: NotificationFilled,
      text: "Notifications",
      onClick: () => history.push("/notifications"),
      activeText: "notifications",
    },
    {
      icon: ScheduleOutlined,
      hoverIcon: ScheduleFilled,
      text: "Schedule",
      onClick: () => history.push("/schedule"),
      activeText: "schedule",
    },
    {
      icon: ChatOutlined,
      hoverIcon: ChatFilled,
      text: "Chat",
      onClick: () => history.push("/chat"),
      activeText: "chat",
    },
    {
      icon: ReviewOutlined,
      hoverIcon: ReviewFilled,
      text: "Reviews",
      onClick: () => history.push("/reviews"),
      activeText: "reviews",
    },
    {
      icon: InsightsOutlined,
      hoverIcon: InsightsFilled,
      text: "Insights",
      onClick: () => history.push("/insights"),
      activeText: "insights",
    },
  ];
  const [menuItem, setMenuItem] = useState("Notifications");
  const staticData = [
    {
      title: "Announcement",
      type: "announcement",
      description: "Added new sports and the ability to complain about users.",
      isSeen: true,
      status: "send-feedback",
    },
    {
      title: "Training report",
      description:
        "How was your last 1-on-1 Tennis Lesson with Ed Collins on Jul 20,2021?",
      isSeen: true,
      type: "training-report",
      status: "",
    },
    {
      title: "1-on-1 Tennis Lesson",
      description: "with Ed Collins on Jul 20",
      isSeen: true,
      type: "training-request",
      status: "cancel-lesson",
      date: "July 17,2021",
    },
    {
      title: "Profile onboarding",
      description: "Your onboarding has been approved.",
      isSeen: true,
      type: "profile-update",
      status: "approved",
    },
    {
      title: "Profile onboarding",
      description:
        "Your onboarding has been declined. Since onboarding check wasn’t approved - your account remains private.",
      isSeen: true,
      type: "profile-update",
      status: "declined",
      date: "July 14, 2021",
    },
    {
      title: "Profile banned",
      description:
        "You canceled classes three times less than 24 hours before the start. Unfortunately, we are forced to ban your profile for 2 weeks. After this period, you can use our application as before.",
      isSeen: true,
      type: "profile-update",
      status: "profile-banned",
    },
    {
      title: "Profile unbanned",
      description:
        "Profile unbanned: Congratulations, your profile is active and you can book your lessons again!",
      isSeen: true,
      type: "profile-update",
      status: "profile-unbanned",
    },
    // ,
    // {
    //   title: "lesson-booked",
    //   description:
    //     "How was your last 1-on-1 Tennis Lesson with Ed Collins on Jul 20,2021?",
    //   isSeen: true,
    //   type: "lesson-booked",
    // },
    // {
    //   title: "lesson-cancelled",
    //   description:
    //     "How was your last 1-on-1 Tennis Lesson with Ed Collins on Jul 20,2021?",
    //   isSeen: true,
    //   type: "lesson-cancelled",
    // },
  ];

  const [notificationdata, setNotificationdata] = useState(staticData);
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setpaginatedData] = useState([]);
  const [isShowModalType, setIsShowModalType] = useState("");
  const [isOpenModal, setIsOpenModal] = useState("");
  const [readAll, setReadAll] = useState(false);

  const [filtercheck, setFiltercheck] = useState([]);
  const filterby = [
    "Announcement",
    "Training report",
    "Training request",
    "Profile update",
    "Lesson booked",
    "Lesson canceled",
    "Payment update",
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const pagelimit = 6;

  useEffect(() => {
    setpaginatedData(() => {
      const startIndex = currentPage * pagelimit - pagelimit;
      const endIndex = startIndex + pagelimit;
      return filteredData?.slice(startIndex, endIndex);
    });
  }, [currentPage, filteredData]);

  // For Filter Data
  function filterData() {
    let types = filtercheck?.map((item) =>
      item?.split(" ").join("-").toLocaleLowerCase()
    );
    if (types?.length == 0) {
      setFilteredData(notificationdata);
    } else {
      let newArr = [];
      notificationdata?.map((item) =>
        types?.map((t) => t == item?.type && newArr.push(item))
      );
      setFilteredData(newArr);
    }
  }

  useEffect(() => {
    filterData();
  }, [filtercheck]);

  return (
    <div className={[classes.NotificationScreen].join(" ")}>
      <SideBarMenu
        logo={ShortLogo}
        items={sidebarMenus}
        state={location?.pathname.split("/")[1]}
        customStyle={{ minHeight: "100vh", height: "auto" }}
      />
      <div className={classes.content}>
        <Container fluid className={[classes.container].join(" ")}>
          <Row className={[classes.row, ""].join(" ")}>
            <Col md={7}>
              <div
                className={[
                  classes.dflex,
                  classes.contentbetween,
                  classes.mb32,
                ].join(" ")}
              >
                <h3 style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}>
                  Notifications
                </h3>
                <LinkButtonWithIcon
                  text="Mark all as read"
                  primary={true}
                  customStyle={{ ...Fonts.b2, lineHeight: "20px" }}
                  leftIcon={readAll ? doubleTickBlueIcon : singleTickBlueIcon}
                  onClick={() => setReadAll(true)}
                />
              </div>

              {paginatedData?.map((item, i) => {
                return (
                  <NotificationBox
                    data={item}
                    onClick1={(type, status) => {
                      setIsShowModalType(type);
                      setIsOpenModal(status);
                      if (status == "go-to-onboarding")
                        history.push("/on-boarding");
                      if (status == "contact-us") history.push("/contact-us");
                      if (status == "chat") history.push("/chat");
                    }}
                    onClick2={(type, status) => {
                      setIsShowModalType(type);
                      setIsOpenModal(status);
                      if (status == "contact-us") history.push("/contact-us");
                    }}
                  />
                );
              })}
            </Col>
            <Col md={5} className={[classes.filterbox].join(" ")}>
              <NotificationFilter
                state={filtercheck}
                setter={setFiltercheck}
                data={filterby}
                isSelectAll={true}
              />
            </Col>
            {/* All this modals should be displayed inside notificationBox component  */}

            {isShowModalType == "announcement" && (
              <>
                <SendFeedbackModal
                  show={isOpenModal == "send-feedback" && true}
                  setShow={() => setIsOpenModal("")}
                  // to show step count in heading
                  // steps="1 out of 3"
                  title="Tell us about your experience with Kate"
                  detailsLabel="Share your feedback about the lesson"
                />
              </>
            )}
            {isShowModalType == "training-report" && (
              <>
                <ReportProblemModal
                  type="message-from-admin"
                  show={isOpenModal == "report" && true}
                  setShow={() => setIsOpenModal("")}
                />
                <ReviewModal
                  title="Tell us about your experience with John"
                  show={isOpenModal == "leave-review" && true}
                  setShow={() => setIsOpenModal("")}
                />
              </>
            )}

            {isShowModalType == "training-request" && (
              <>
                <CancelLesson
                  show={isOpenModal == "cancel-lesson" && true}
                  setShow={() => setIsOpenModal("")}
                />
              </>
            )}

            {/* <SuccessFeedbackModal
              show={isShowModal=='send-feedback' && true}
              setShow={setIsShowModal}
 
              title="Thank you!"
              description="You review was successfully sent."
            /> */}
            {/* type when admin gives feedback */}
            {/* <DeclinedModal
              title="Certification declined"
              contactBtn="Contact us"
              updateBtn="Update certificate"
            /> */}
            <ReviewModal
            // show={isShowModalStatus == "send-review" && true}
            // setShow={setIsShowModalStatus}
            />
            {/* Pagination */}
            <Col md={12} className={classes.lastCol}>
              <PaginationComponent
                totalPages={Math.ceil(filteredData.length / pagelimit)}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

const NotificationDetail = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <NotificationMobile /> : <NotificationDesktop />;
};

export default NotificationDetail;
